import React from 'react'
import CardSimple from '../../../../components/basic/CardSimple';

const CheckIn = () => {
    return (
        <div id="check-in">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to use the Check In Feature</h2>
                        <p><strong>NOTE:</strong> This feature was made for stores with a receptionist and a high flow of customers</p>
                        <ul>
                            <li>In Menu {`>`} Users {`>`} Members each Member will have a “Check In” button beside their name</li>
                            <img src="http://techpos.ca/support-images/CheckIn/CheckIn-1.png" />
                            <li>Hit this button to add the Member to the Check In list</li>
                            <img src="http://techpos.ca/support-images/CheckIn/CheckIn-2.png" />
                            <li>This list will be available by clicking this symbol found at the top right of any screen of any system in the store,
                                however the option to Start Order will only be available from the POS Sales screen.</li>
                            <img src="http://techpos.ca/support-images/CheckIn/CheckIn-4.png" />
                            <li>Simply click the “Start Order” button beside the Member to begin the transaction and remove them from the Check In list</li>
                            <img src="http://techpos.ca/support-images/CheckIn/CheckIn-5.png" />
                            <li>(Refer to How to use POS Sales)</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default CheckIn;